/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import { createReducer, SUCCESS, updateObject } from 'Stores'
import { ACCOUNT_LIST } from './constants'

export const initialState = {
  type: null,
  accountList: []
}

function getAccountListSuccess(state, { payload }) {
  const { accountList } = payload
  return updateObject(state, {
    accountList
  })
}

export default createReducer(initialState, {
  [SUCCESS(ACCOUNT_LIST)]: getAccountListSuccess
})
